import { render } from "./RegionDashboardsDynamicCard.vue?vue&type=template&id=3ce402d2&scoped=true&ts=true"
import script from "./RegionDashboardsDynamicCard.vue?vue&type=script&lang=ts"
export * from "./RegionDashboardsDynamicCard.vue?vue&type=script&lang=ts"

import "./RegionDashboardsDynamicCard.vue?vue&type=style&index=0&id=3ce402d2&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce402d2"]])

export default __exports__